import { RoobiniumMark } from '@/components/elements';

interface DemoHeaderProps {
    badge: string;
    title: string;
}

export const DemoHeader = ({ badge, title }: DemoHeaderProps) => {
    return (
        <div className="flex items-start justify-between">
            <div className="space-y-3">
                <div className="badge badge-lg bg-white/10 border-0 text-white font-montserrat font-semibold uppercase tracking-wide">
                    {badge}
                </div>
                <h1 className="text-white text-7xl font-extrabold font-montserrat leading-[72px]">{title}</h1>
            </div>
            <div className="flex items-center gap-7">
                <div className="space-y-0.5">
                    <p className="font-montserrat text-base font-semibold">roobiniumDESIGN</p>
                    <div className="flex items-center gap-1.5">
                        <span className="text-xs text-gray-400/60 font-montserrat">v1.0</span>
                        <div className="w-1 h-1 bg-white/25 rounded-full" />
                        <span className="text-xs text-gray-400/60 font-montserrat">okt5, 2022</span>
                    </div>
                </div>
                <div className="w-14 h-14">
                    <RoobiniumMark />
                </div>
            </div>
        </div>
    );
};